<template>
	<div class="flex gap-2 text-center">
		<div v-for="(item, index) in gramSuggestions" v-bind:key="`${index}${item.shown}`"
			class="flex-1 bg-grey-11 rounded cursor-pointer p-1" @click="useGram(item.value)">
			{{ item.shown }}
		</div>
	</div>
</template>

<script>
import { configs } from '@bei/trading-formula'

import utils from '../../../utils'

export default {
	name: 'GramSuggestions',

	props: {
		contractId: [Number, String],
	},

	data() {
		return {
			gramSuggestions: [],
		}
	},

	computed: {
		contractConfigs() {
			return configs.contractConfigs[this.contractId]
		},
	},

	created() {
		this.initializeGramSuggestions()
	},

	methods: {
		initializeGramSuggestions() {
			const gramSuggestions = this.contractConfigs.gramSuggestions

			gramSuggestions.forEach((gram) => {
				this.gramSuggestions.push({
					shown: utils.currencyFormat(gram),
					value: gram
				})
			})
		},

		useGram(gram) {
			this.$emit('useGram', gram)
		}
	},
}
</script>